import { useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Une photo en grand, dans l'application : « quand je clique sur la photo, ça
 * ne s'agrandit pas ». Un lien vers un nouvel onglet ne s'ouvre pas dans
 * l'application installée sur l'iPhone ; ici, la photo couvre l'écran, un
 * toucher l'agrandit encore, « Fermer » ou un toucher à côté la referme.
 *
 * @param {object} props propriétés
 * @param {string} props.src adresse de l'image
 * @param {string} [props.legende] ce que la photo montre
 * @param {() => void} props.onFerme referme la photo
 * @returns {import('react').ReactElement} la photo en plein écran
 */
export function PhotoPleinEcran({ src, legende, onFerme }) {
  const [zoom, setZoom] = useState(false);
  const vue = (
    <div
      role="dialog"
      aria-label={legende || 'Photo'}
      onClick={onFerme}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.97)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        padding: 12,
        paddingTop: 'max(12px, var(--st-haut, 0px), env(safe-area-inset-top, 0px))',
        paddingBottom: 'max(12px, env(safe-area-inset-bottom, 0px))',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 8 }}>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setZoom((z) => !z);
          }}
          style={bouton}
        >
          {zoom ? '🔍 −' : '🔍 +'}
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onFerme();
          }}
          style={bouton}
        >
          ✕ Fermer
        </button>
      </div>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          display: 'flex',
          alignItems: zoom ? 'flex-start' : 'center',
          justifyContent: zoom ? 'flex-start' : 'center',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <img
          src={src}
          alt={legende || 'Photo'}
          onClick={() => setZoom((z) => !z)}
          style={
            zoom
              ? { width: '250%', maxWidth: 'none', height: 'auto', cursor: 'zoom-out' }
              : {
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  borderRadius: 8,
                  cursor: 'zoom-in',
                }
          }
        />
      </div>
      {legende && (
        <div style={{ color: '#fff', fontSize: 12, marginTop: 8, textAlign: 'center' }}>
          {legende}
        </div>
      )}
    </div>
  );
  // Posée sur la page entière : dans une feuille A4 réduite à l'écran, une
  // photo « fixe » restait prise dans la feuille.
  return typeof document !== 'undefined' ? createPortal(vue, document.body) : vue;
}

const bouton = {
  background: 'rgba(255,255,255,.18)',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: '9px 14px',
  fontSize: 13,
  fontWeight: 800,
  cursor: 'pointer',
};
